<template>
  <!-- 展会申请详情页面 -->
  <div class="page-container">
    <!-- 顶部区域：申请详情 + 绑定展位 -->
    <div class="apply-block-top">
      <!-- 申请详情区块 -->
      <div class="page-card" style="width: 880px; margin-right: 20px; margin-bottom: 20px; float: left">
        <div class="page-card__header">
          <span style="font-weight: bold">展会申请详情</span>
        </div>
        <div class="page-card__body" style="font-size: 14px; line-height: 30px; width: 800px">
          <el-row :gutter="20">
            <el-col :span="4" style="text-align: right">
              公司名称：
            </el-col>
            <el-col :span="20" style="text-align: left">
              广东金蜘蛛电脑网络有限公司
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="4" style="text-align: right">
              联系人：
            </el-col>
            <el-col :span="20" style="text-align: left">
              陈小姐
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="4" style="text-align: right">
              职务：
            </el-col>
            <el-col :span="20" style="text-align: left">
              采购
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="4" style="text-align: right">
              手机号码：
            </el-col>
            <el-col :span="20" style="text-align: left">
              13666666666
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="4" style="text-align: right">
              Email：
            </el-col>
            <el-col :span="20" style="text-align: left">
              441414142366@qq.com
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="4" style="text-align: right">
              意向面积：
            </el-col>
            <el-col :span="20" style="text-align: left">
              45
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="4" style="text-align: right">
              展位类型：
            </el-col>
            <el-col :span="20" style="text-align: left">
              摊位
            </el-col>
            <el-row :gutter="20">
              <el-col :span="4" style="text-align: right">
                备注：
              </el-col>
              <el-col :span="20" style="text-align: left">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod
                bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra
                justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque
                penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci,
                sed rhoncus pronin sapien nunc accuan eget.
              </el-col>
            </el-row>
          </el-row>
        </div>
      </div>

      <!-- 绑定展位区块 -->
      <div class="page-card" style="width: 300px; float: left">
        <div class="page-card__header">
          <span style="font-weight: bold">绑定展位</span>
        </div>
        <div class="page-card__body">
          <div style="height:78px;width:300px;">
          </div>
        </div>
      </div>
    </div>

    <!-- 底部区域：备注记录 + 录入备注 -->
    <div class="apply-block-bottom">
      <!-- 备注记录区块 -->
      <div class="page-card" style="width: 880px; margin-right: 20px; float: left">
        <div class="page-card__header">
          <span style="font-weight: bold">广东金蜘蛛电脑网络有限公司</span>
        </div>
        <div class="page-card__header">
          <span style="font-weight: bold">备注记录</span>
        </div>

        <div v-for="i in 3" :key="i" style="margin: 0 16px; clear: both; font-size: 14px; text-align: left;
        width: 800px; border-bottom: 1px solid var(--border-color); padding: 16px">
          <div style="color: var(--color-primary)">
            <el-row>
              <el-col :span="4">
                2022-07-20 13:50
              </el-col>
              <el-col :span="4">
                记录人：车大炮
              </el-col>
            </el-row>
          </div>
          <div style="margin-top: 16px">
            <el-row>
              <el-col :span="24">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum
                laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.
                Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis
                parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra
                vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!-- 录入备注区块 -->
      <div class="page-card" style="width: 300px; min-height: 300px; float: left">
        <div class="page-card__header">
          <span style="font-weight: bold">录入备注</span>
        </div>
        <div class="page-card__body" style="width:260px; font-size: 14px">
          <el-form ref="form" :model="form">
            <div style="font-size: 14px; text-align: left; line-height: 30px">记录人：</div>
            <el-form-item>
              <el-input v-model="form.name" placeholder="填写记录人的姓名"></el-input>
            </el-form-item>
            <div style="font-size: 14px; text-align: left; line-height: 30px">备注：</div>
            <el-form-item>
              <el-input type="textarea" v-model="form.content" rows="4" placeholder="填写备注内容"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" round size="small">确认添加</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      form: {
        name: '',
        content: '',
      }
    }
  },
  methods: {
    // 跳转到详情页
    to_infoDetail(row) {
      this.$router.push({name: 'infoDetail'})
    },
    // 跳转到详情页（通过ID）
    go_detailId: function () {
      this.$router.push({name: 'infoDetail'})
    },
  }
}
</script>

<style scoped>
  .apply-block-top {
    height: auto;
    clear: both
  }

  .apply-block-bottom {
    clear: both;
    margin: 20px 0;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/applyBooth.vue